<template>
  <div class="content flex flex-col xl:flex-row justify-between p-0" v-for="c in comments" :key="c.id">
    <div class="left-data">
      <div class="line"></div>
      <div class="name">{{ c.user }}</div>
      <div class="photo" :style="{backgroundImage: 'url('+c.avatar+')'}"></div>
      <div class="tarja" :style="{backgroundColor: c.tarja_cor}">{{ c.tarja_text }}</div>
      <div class="count">{{ c.comments }} comentários</div>
      <div class="badges">
        <div class="box" v-for="(b, i) in c.badges" :key="i" :style="{backgroundImage: 'url('+b.badge+')'}">
          <ToolTip :title="b.title+'<br>'+b.description" top="-105%" line="25px" />
        </div>
      </div>
    </div>
    <div class="text text-topic xl:w-[calc(100%_-_220px)]">
      <div class="read" v-html="c.texto"></div>
      <div class="cite"><i class="fa-solid fa-quote-right"></i></div>
    </div>
  </div>
  <div class="pagination">
    <button v-for="(p, i) in pags" :key="i" :disabled="pag == p" :class="{active: pag == p}"
            @click="() => {getCom(p); pag = p}">{{ p }}
    </button>
  </div>
  <Transition name="slide-fade">
    <ItemPerfil v-if="showP" @close="showP = false" :user="perfilName" />
  </Transition>
</template>

<script setup>
import ItemPerfil from '@/components/modals/perfil.vue'
import ToolTip from '@/components/usefulness/tooltip.vue'
import { getTopicComments } from '@/services/api.js'
import { ref } from 'vue'

const props = defineProps({
  id: {
    type: [Number, String, Object],
    required: true
  },
  type: {
    type: [String, Object],
    required: true
  }
})

const comments = ref([])
const showP = ref(false)
const perfilName = ref('')
const pag = ref(1)
const pags = ref([])

async function getCom() {
  comments.value = await getTopicComments(props.id)
}

getCom()

</script>

<style scoped>
.content .left-data {
  position: relative;
  width: 220px;
  height: auto;
  background-color: #f7f6f6;
  border-radius: 12px 0 12px 12px;
  padding: 10px 0;
}

.content .left-data .line {
  position: absolute;
  top: 0;
  left: 50%;
  transform: translateX(-50%);
  width: 54px;
  height: 4px;
  background-color: #2EC044;
  border-radius: 0 0 4px 4px;
}

.content .left-data .name {
  width: 100%;
  height: 20px;
  font-size: 18px;
  font-weight: 700;
  text-align: center;
  margin-top: 16px;
}

.content .left-data .photo {
  width: 100%;
  height: 220px;
  background-color: #ccc;
  background-position: center;
  background-repeat: no-repeat;
  background-size: cover;
  border-radius: 0 12px 0 0;
  margin-top: 25px;
}

.content .left-data .tarja {
  width: 100%;
  height: 44px;
  background-color: #35B6FF;
  color: #fff;
  font-size: 15px;
  font-weight: 700;
  text-align: center;
  line-height: 44px;
  user-select: none;
  border-radius: 0 0 12px 0;
}

.content .left-data .count {
  width: 100%;
  height: 20px;
  margin-top: 10px;
  font-size: 13px;
  font-weight: 500;
  color: #555;
  text-align: center;
  line-height: 20px;
}

.content .left-data .badges {
  width: 100%;
  height: auto;
  padding: 0 20px;
  margin-top: 20px;
  display: flex;
  justify-content: space-between;
  flex-wrap: wrap;
}

.content .left-data .badges .box {
  position: relative;
  width: 50px;
  height: 50px;
  border-radius: 12px;
  background-position: center;
  background-repeat: no-repeat;
  margin-top: 6px;
}

.content .text-topic {
  position: relative;
}

.content .text .read {
  padding: 10px;
  font-size: 14px;
}

.content .text .cite {
  position: absolute;
  right: 0;
  bottom: 20px;
  width: 80px;
  height: 54px;
  background-color: #E4EFF3;
  border-radius: 50px 0 0 50px;
  font-size: 16px;
  text-align: center;
  line-height: 54px;
  user-select: none;
}

.pagination {
  float: left;
  width: 100%;
  height: 40px;
  display: flex;
  justify-content: center;
  margin-top: 20px;
}

.pagination button {
  width: auto;
  height: 100%;
  background-color: var(--color1);
  border-radius: 20px;
  color: #fff;
  font-size: 14px;
  font-weight: 500;
  padding: 0 20px;
  margin-left: 8px;
}

.pagination button.active {
  background-color: #2EC044;
}

.pagination button:disabled {
  opacity: 1;
}


@media only screen and (max-width: 500px) {
  .content {
    display: block;
  }

  .content .left-data {
    width: 100%;
    border-radius: 12px;
  }

  .content .text-topic {
    width: 100%;
    min-height: 140px;
  }
}
</style>
